import MegaOptionsContainer from "../../../../components/formsAndTable/forms/formControls/megaOptions";

const MegaOptions = () => {
  return <MegaOptionsContainer />;
};

export default MegaOptions;
